export const fixOverlayScroll = (state: boolean) => {
  const body = document.body
  body.style.maxHeight = state ? '100%' : ''
  body.style.overflow = state ? 'hidden' : ''
}
